module.exports = __webpack_public_path__ + "static/media/C-01.922e1736.png";